export default "__VITE_ASSET__pjRv_U5k__"